import { render, staticRenderFns } from "./SurveyTake.vue?vue&type=template&id=584eb49c&scoped=true"
import script from "./SurveyTake.vue?vue&type=script&lang=js"
export * from "./SurveyTake.vue?vue&type=script&lang=js"
import style0 from "./SurveyTake.vue?vue&type=style&index=0&id=584eb49c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584eb49c",
  null
  
)

export default component.exports